import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAppState } from '../../store/state';
import { selectIsLogged, selectUser } from '../../store/selectors';
import { LayoutService } from '../../services/layout/layout.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  isLogged$ = this.store.select(selectIsLogged);
  user$ = this.store.select(selectUser);

  constructor(private store: Store<IAppState>, private layout: LayoutService) {}

  toggleSidenav(): void {
    this.layout.toggleSidenav();
  }
}
